import {
    DENY_OVERRIDE,
    DENY_OVERRIDE_SUCCESS,
    DENY_OVERRIDE_FAILURE,
    RESET_DENY_OVERRIDE,
} from '../actions';

const initialState = {
    loading: false,
    response: null,
    statusCode: '',
    statusMessage: '',
};

const denyOverrideReducer = (state = initialState, action) => {
    switch (action.type) {
        case DENY_OVERRIDE:
            return {
                ...state,
                loading: true,
                response: null,
                statusCode: '',
                statusMessage: '',
            };
        case DENY_OVERRIDE_SUCCESS:
            return {
                ...state,
                loading: false,
                response: action.data,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case DENY_OVERRIDE_FAILURE:
            return {
                ...state,
                loading: false,
                response: null,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case RESET_DENY_OVERRIDE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default denyOverrideReducer;
